/**
 * Trap focus inside element
 * @param {*} element
 */
let focusTrap = element => {
	// Get all focusable elements
	let focusableEls = element.querySelectorAll(
		'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
	);

	// First focus
	let firstFocusableEl = focusableEls[0];

	// Last focus
	let lastFocusableEl = focusableEls[focusableEls.length - 1];

	// Window listener
	window.addEventListener("keydown", function (e) {
		if (e.key === "Tab" || e.keyCode === 9) {
			if (e.shiftKey) {
				/* shift + tab */
				if (document.activeElement === firstFocusableEl) {
					lastFocusableEl.focus();
					e.preventDefault();
				}
			} /* tab */
			else {
				if (document.activeElement === lastFocusableEl) {
					firstFocusableEl.focus();
					e.preventDefault();
				}
			}
		}
	});
};
export default focusTrap;
